import {ChangeDetectionStrategy, Component, inject, Injector, Input, OnInit} from '@angular/core';
import {Params} from '@angular/router';
import {NgTemplateOutlet} from '@angular/common';
import {TruncateDirective} from '@aviary/directives/truncate.directive';
import {FormatPipe} from '@aviary/pipes/format.pipe';
import {DetailFieldDefaults, MX_DETAIL_FIELD_DEFAULTS} from './detail-field-defaults/detail-field.defaults';
import {BaseNamedRouterLinkDirective} from '@aviary/directives/base-named-router-link.directive';

@Component({
  selector: 'mx-detail-field',
  templateUrl: './detail-field.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgTemplateOutlet, TruncateDirective, FormatPipe, BaseNamedRouterLinkDirective]
})
export class DetailFieldComponent implements OnInit {

  @Input() public titleText?: string;
  @Input() public truncateTitleText?: boolean;
  @Input() public truncateTitleTextMaxLines?: number;  // Ignored when truncateTitleText is false.
  @Input() public value?: string | number;
  @Input() public truncateValue?: boolean;
  @Input() public truncateValueMaxLines?: number;  // Ignored when truncateValue is false.
  @Input() public titleCSSClasses?: string;
  @Input() public valueCSSClasses?: string;
  @Input() public valueRouterLink?: string;
  @Input() public valueRouterLinkParams: Params = {};
  @Input() public valueRouterLinkQueryParams: Params = {};
  @Input() public asRow?: boolean;
  @Input() public fullWidth?: boolean;  // Ignored when asRow is false.

  private readonly injector: Injector = inject(Injector);

  public ngOnInit(): void {
    const defaults: DetailFieldDefaults = this.injector.get(MX_DETAIL_FIELD_DEFAULTS, {} as DetailFieldDefaults);

    this.truncateTitleText ??= defaults?.truncateTitleText ?? true;
    this.truncateTitleTextMaxLines ??= defaults?.truncateTitleTextMaxLines ?? 2;
    this.truncateValue ??= defaults?.truncateValue ?? true;
    this.truncateValueMaxLines ??= defaults?.truncateValueMaxLines ?? 2;
    this.titleCSSClasses ??= defaults?.titleCSSClasses ?? 'text-title-medium';
    this.valueCSSClasses ??= defaults?.valueCSSClasses ?? 'text-body-medium';
    this.asRow ??= defaults?.asRow ?? false;
    this.fullWidth ??= defaults?.fullWidth ?? false;
  }
}
